
    import Vue from "vue";
    import Component from "vue-class-component";
    import ApplicationAdditionalInfoInput from "@/features/applications/components/ApplicationAdditionalInfoInput.vue"
    import {
        ApplicationsClient,
        ApplicationViewModel,
        CertificateRequirementViewModel,
        factory,
        MedicalCertificateRequirementViewModel,
        PositionsRequirementViewModel,
        PracticesRequirementViewModel,
        QualificationRequirementViewModel,
        RequirementFulfillmentViewModel,
        PersonalInfoRequirementViewModel,
        ResultError,
        StateFeeRequirementViewModel,
        FilesRequirementViewModel,
        DuplicationReasonRequirementViewModel,
        ApplicationActions,
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import ApplicationStateBadge from "@/features/applications/components/ApplicationStateBadge.vue";
    import QualificationRequirementSummary
        from "@/features/applications/components/requirements/QualificationRequirementSummary.vue";
    import MedicalCertificateRequirementSummary
        from "@/features/applications/components/requirements/MedicalCertificateRequirementSummary.vue";
    import CertificateRequirementSummary from "@/features/applications/components/requirements/CertificateRequirementSummary.vue";
    import PositionsRequirementSummary from "@/features/applications/components/requirements/PositionsRequirementSummary.vue";
    import PracticeRequirementSummary
      from "@/features/applications/components/requirements/PracticeRequirementSummary.vue";
    import DeliveryMethodSummary from "@/features/applications/components/DeliveryMethodSummary.vue";
    import PersonalInfoRequirementSummary
      from "@/features/applications/components/requirements/PersonalInfoRequirementSummary.vue";
    import StateFeeRequirementSummary
      from "@/features/applications/components/requirements/stateFee/StateFeeRequirementSummary.vue";
    import FilesRequirementSummary from "@/features/applications/components/requirements/FilesRequirementSummary.vue";
    import ApplicationOverviewLayout from "@/features/applications/components/ApplicationOverviewLayout.vue";
    import ConfirmModal from "@/features/shared/components/ConfirmModal.vue";
    import translateApplicationType from "@/features/applications/components/ApplicationTypeTranslator";
    import DuplicationReasonRequirementSummary from "@/features/applications/components/requirements/DuplicationReasonRequirementSummary.vue";
    import ApplicationDetails from "@/features/applications/components/ApplicationDetails.vue";
    import ErrorsSummary from "@/components/ErrorsSummary.vue";
    import toasts from "@/components/Toasts";

    @Component({
        components: {
            ApplicationDetails,
            ApplicationStateBadge,
            QualificationRequirementSummary,
            MedicalCertificateRequirementSummary,
            CertificateRequirementSummary,
            PositionsRequirementSummary,
            PracticeRequirementSummary,
            PersonalInfoRequirementSummary,
            DeliveryMethodSummary,
            StateFeeRequirementSummary,
            FilesRequirementSummary,
            DuplicationReasonRequirementSummary,
            ApplicationOverviewLayout,
            ConfirmModal,
            ErrorsSummary,
            ApplicationAdditionalInfoInput
        },
        methods: {
            translateApplicationType
        }
    })
  export default class ApplicationSummary extends Vue {
        @Prop({required: true})
        application!: ApplicationViewModel;

        @Prop({required: true})
        actions!: ApplicationActions;

        errors: ResultError = factory.create(ResultError);

        $refs!: {
            confirmIssueDocumentWithoutComment: ConfirmModal
        }

        getRequirementComponentName(fulfillment: RequirementFulfillmentViewModel) {
            if (fulfillment.requirement instanceof QualificationRequirementViewModel) {
                return "qualification-requirement-summary";
            }
            if (fulfillment.requirement instanceof MedicalCertificateRequirementViewModel) {
                return "medical-certificate-requirement-summary";
            }
            if (fulfillment.requirement instanceof CertificateRequirementViewModel) {
                return "certificate-requirement-summary";
            }
            if (fulfillment.requirement instanceof PositionsRequirementViewModel) {
                return "positions-requirement-summary";
            }
            if (fulfillment.requirement instanceof PracticesRequirementViewModel) {
                return "practice-requirement-summary";
            }
            if (fulfillment.requirement instanceof PersonalInfoRequirementViewModel) {
                return "personal-info-requirement-summary";
            }
            if (fulfillment.requirement instanceof FilesRequirementViewModel) {
                return "files-requirement-summary";
            }
            if (fulfillment.requirement instanceof StateFeeRequirementViewModel) {
                return "state-fee-requirement-summary";
            }
            if (fulfillment.requirement instanceof DuplicationReasonRequirementViewModel) {
                return "duplication-reason-requirement-summary";
            }
            throw `Unknown requirement type: ${fulfillment.requirement.name}`;
        }

        async submit() {
            new ApplicationsClient().submit(this.application.id).then(
                () => {
                    this.$emit("application-changed");
                    this.$router.push({name: "ApplicationOverview"});
                },
                error => {
                    this.errors = error;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
        }

        async takeOverProcessing() {
            await new ApplicationsClient().takeOverProcessing(this.application.id).then(
                () => this.$emit("application-changed"),
                error => {
                    this.errors = error;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
        }

    }
